module.exports = __webpack_public_path__ + "img/document.4b157a8b.svg";